<template>
  <!--  -->
  <div class="content">
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px">日期:</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  @change="doFilter"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ (currentPage - 1) * pageSize + scope.$index + 1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="部位">
                <template slot-scope="scope">
                  <span>{{ scope.row.part }}</span>
                </template>
              </el-table-column>
              <el-table-column label="厂家">
                <template slot-scope="scope">
                  <span>{{ scope.row.factory }}</span>
                </template>
              </el-table-column>
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span>{{ scope.row.location }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.date }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        personName: '',
        date: '',
        projectId: '',
        status:'',
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      attendType: [],

      // types:[],//进出类型
    }
  },
  created() {
    if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
    }else{
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {
    //this.search.projectId = util.session.get('groupId')
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // console.log(this.search.projectId)
    if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
    }else{
      this.search.projectId = util.session.get('proId')
    }
    // this.getDict() //获取考勤
    this.getData()
  },
  methods: {
    //获取字典
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            }
            that.attendType = list
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      if(this.search.date==''||this.search.date=='2021-07-10'){
        this.listData = [
          {id:'1',name:'预制实心板',part:'楼板',location:'1号楼',factory:'建筑公司',date:'2021-07-10'},
          {id:'2',name:'预制实心梁',part:'预制梁',location:'1号楼',factory:'建筑公司',date:'2021-07-10'},
          {id:'3',name:'预制实心剪力墙',part:'预制墙',location:'1号楼',factory:'建筑公司',date:'2021-07-10'},
          {id:'4',name:'预制实心柱',part:'预制柱',location:'1号楼',factory:'建筑公司',date:'2021-07-10'},
        ]
        this.totalItems = 4
      }else{
        this.listData = []
        that.dataText = '暂无数据'
        this.totalItems = 0
      }
      
      // myHttp.getAttendList(this.search).then(
      //   function(resp) {
      //     if (resp.data.code == '200') {
      //       var list = resp.data.data.pageInfo.list || []
      //       for (var i = 0; i < list.length; i++) {
      //         list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
      //         list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
      //         list[i].typeName = that.filterSatus(list[i].status)
      //       }
      //       that.listData = list
      //       that.totalItems = resp.data.data.pageInfo.total || 0
      //       if (that.listData.length == 0) {
      //         that.dataText = '暂无数据'
      //       }
      //     } else {
      //       that.$message.error(resp.data.msg)
      //       that.dataText = '暂无数据'
      //     }
      //   },
      //   function() {}
      // )
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
        myHttp.exportAttendList +
          '?projectId=' +
          this.search.projectId +
          '&personName=' +
          this.search.personName +
          '&date=' +
          this.search.date +
          '&accessToken=' +
          token
      )
    },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index,row){
        var port = util.session.get('roleId')
        if(port=='4'){
            this.$router.push({name: 'workerInfo',params: { id: row.personId }})
        }else if(port=='5'||port=='3'){
             this.$router.push({name: 'workerInfoCom',params: { id: row.personId }})
         }  
    
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },

    filterTag(filters) {
        // console.log(filters)
        this.search.status = filters.aStatus[0]
        this.getData()
    }
    
  }
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-input-group--append .el-input__inner{
      width: 200px;
    }
</style>